import { Action } from "../../../../../types/state/action";
import {
  IColor,
  IDecorationTech,
  IMold,
} from "../../../../../types/data.interface";
import { CreateArtworkCollectionState } from "../../collection/create/data";

type ValueOrNull<T> = T | null;
export type Option<T> = { value: T; label: string };

export type CreatePrintingTechniqueState = {
  id?: string;
  name: string;
  code: string;
  image?: any; //TODO: THIS SHOULD BE Blob | MediaSource ;
  picture?: any; //TODO: THIS SHOULD BE Blob | MediaSource ;
  collection: CreateArtworkCollectionState;
  color: ValueOrNull<IColor>;
  purchased_parts: string;
  molds: ValueOrNull<IMold[]>;
  decoration_technique: ValueOrNull<IDecorationTech>;
  technical_file_comment: string;
  submit_comment: string;
  reject_reason?: any;
  isReadOnly: boolean;
  history: {
    id: number,
    date: string,
    comment: string,
    status_reason: string,
    status: number,
    collection: number,
    requester: string,
    revisor: string,
    approver: string
  }[];
  status: ValueOrNull<{id:number, name:string}>;
  isValid: boolean;

};

export enum CreatePrintingTechniqueTypes {
  SET_PRINTING_TECHNIQUE = "setPrintingTechnique",
  SET_NAME = "name",
  SET_CODE = "code",
  SET_IMAGE = "image",
  SET_PICTURE = "picture",
  SET_COLLECTION = "collection",
  SET_COLOR = "color",
  SET_PURCHASED_PARTS = "purchased_parts",
  SET_MOLDS = "molds",
  SET_DECORATION_TECHNIQUE = "decoration_technique",
  SET_COMMENT = "comment",
  SET_IS_READ_ONLY = "isReadOnly",
  SET_STATUS = "status",
  SET_SUBMIT_COMMENT = "submit_comment",
  SET_TECHNICAL_FILE_COMMENT = "technical_file_comment",
  SET_REJECT_REASON = "reject_reason",
  SET_IS_VALID = "isValid",

}

export type CreatePrintingTechniqueType = Action<
  CreatePrintingTechniqueTypes,
  Partial<CreatePrintingTechniqueState>
>;
